import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Medal } from "lucide-react";
import { tierNudgeState } from "@/lib/badges";

const fmtH = (v) => String(Math.round(v * 10) / 10);

// "So close" nudge under the dashboard greeting. Only renders when the
// volunteer has started logging AND is within 5 approved hours of the next
// tier (logic in lib/badges tierNudgeState — unit-tested there). Prefers a
// matched/recommended opportunity whose required hours close the gap in one
// go; otherwise falls back to a plain browse link.
export const TierNudge = ({ stats, matched, recs }) => {
  const s = tierNudgeState(stats?.total_hours, [...(matched || []), ...(recs?.items || [])]);
  if (!s) return null;
  return (
    <div
      data-testid="tier-nudge"
      className="mt-6 flex items-center gap-3 flex-wrap rounded-2xl border px-5 py-4"
      style={{ borderColor: `${s.next.color}40`, backgroundColor: `${s.next.color}0D` }}
    >
      <Medal className="w-5 h-5 shrink-0" style={{ color: s.next.color }} />
      <div data-testid="tier-nudge-text" className="flex-1 min-w-[220px] text-sm text-neutral-700">
        <span className="font-semibold" style={{ color: s.next.color }}>
          {fmtH(s.remaining)}h to {s.next.label}
        </span>
        {s.pick
          ? <> — “{s.pick.title}” ({fmtH(s.pick.hours_required)}h) would take you there.</>
          : <> — one more session could tip you over.</>}
      </div>
      <Link
        to={s.pick ? `/opportunities/${s.pick.id}` : "/opportunities"}
        data-testid={s.pick ? "tier-nudge-opportunity-link" : "tier-nudge-browse-link"}
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-forest hover:underline shrink-0"
      >
        Find your next opportunity <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};
